import { render } from "./ZoneConsents.vue?vue&type=template&id=993376d2&ts=true"
import script from "./ZoneConsents.vue?vue&type=script&lang=ts"
export * from "./ZoneConsents.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Zones/ZoneConsents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "993376d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('993376d2', __exports__)) {
    api.reload('993376d2', __exports__)
  }
  
  module.hot.accept("./ZoneConsents.vue?vue&type=template&id=993376d2&ts=true", () => {
    api.rerender('993376d2', render)
  })

}


export default __exports__